/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2022/05/18
 * @created by      :   ANS874 – quanhvm@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const ra001600i = () => import('@/views/input/ra001600i');
const ra200900i = () => import('@/views/input/ra200900i');
const ra201200i = () => import('@/views/input/ra201200i');
const ra201500i = () => import('@/views/input/ra201500i');
const ra300200i = () => import('@/views/input/ra300200i');
const ra300200i_confirm = () => import('@/views/input/ra300200i_confirm');
const ra300400i = () => import('@/views/input/ra300400i');
const ra300400i_check = () => import('@/views/input/ra300400i_check');
const ra300100i = () => import('@/views/input/ra300100i');
const ra300600i = () => import('@/views/input/ra300600i');
const ra300400i_confirm = () => import('@/views/input/ra300400i_confirm');
const ra300500i = () => import('@/views/input/ra300500i');
const ra300500i_complete = () => import('@/views/input/ra300500i_complete');
const ra300700i = () => import('@/views/input/ra300700i');
const ra300700i_check = () => import('@/views/input/ra300700i_check');
const ra300700i_sign = () => import('@/views/input/ra300700i_sign');
const ra300700i_confirm = () => import('@/views/input/ra300700i_confirm');
const ra300700i_complete = () => import('@/views/input/ra300700i_complete');

/**
 * Defined Router
 */
export default [
    {
        path: '/input/ra001600i',
        name: 'ra001600i',
        component: ra001600i,
        meta: {
            title: '物件情報登録'
        }
    },
    {
        path: '/input/ra200900i',
        name: 'ra200900i',
        component: ra200900i,
        meta: {
            title: '物件情報登録',
            isClientPage: true
        }
    },
    {
        path: '/input/ra201200i',
        name: 'ra201200i',
        component: ra201200i,
        meta: {
            title: '新規入場者登録の事前依頼',
            isClientPage: true
        }
    },
    {
        path: '/input/ra201500i',
        name: 'ra201500i',
        component: ra201500i,
        meta: {
            title: '作業日毎の完了確認',
            isClientPage: true
        }
    },
    {
        path: '/mobile/ra300200i',
        name: 'ra300200i',
        component: ra300200i,
        meta: {
            title: '新規入場者登録(1/6)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300200i/confirm',
        name: 'ra300200i_confirm',
        component: ra300200i_confirm,
        meta: {
            title: '新規入場者登録(2/6)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300400i',
        name: 'ra300400i',
        component: ra300400i,
        meta: {
            title: '新規入場者登録(3/6)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300400i/check',
        name: 'ra300400i_check',
        component: ra300400i_check,
        meta: {
            title: '新規入場者登録(4/6)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300100i',
        name: 'ra300100i',
        component: ra300100i,
        meta: {
            title: '認証コードの入力',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300600i',
        name: 'ra300600i',
        component: ra300600i,
        meta: {
            title: '新規入場者登録の入力',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300400i/confirm',
        name: 'ra300400i_confirm',
        component: ra300400i_confirm,
        meta: {
            title: '新規入場者登録(5/6)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300500i',
        name: 'ra300500i',
        component: ra300500i,
        meta: {
            title: '新規入場者登録(6/6)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300500i/complete',
        name: 'ra300500i_complete',
        component: ra300500i_complete,
        meta: {
            title: '新規入場者登録の入力',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300700i',
        name: 'ra300700i',
        component: ra300700i,
        meta: {
            title: '工事安全書類の確認(1/4)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300700i/check',
        name: 'ra300700i_check',
        component: ra300700i_check,
        meta: {
            title: '工事安全書類の確認(2/4)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300700i/sign',
        name: 'ra300700i_sign',
        component: ra300700i_sign,
        meta: {
            title: '工事安全書類の確認(3/4)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300700i/confirm',
        name: 'ra300700i_confirm',
        component: ra300700i_confirm,
        meta: {
            title: '工事安全書類の確認(4/4)',
            isIsMobile: true
        }
    },
    {
        path: '/mobile/ra300700i/complete',
        name: 'ra300700i_complete',
        component: ra300700i_complete,
        meta: {
            title: '工事安全書類の確認(4/4)',
            isIsMobile: true
        }
    }
];
